<div class="flex-column" style="align-items: center;" [formGroup]="form">
  <span matDialogTitle style="margin-bottom: 2rem;">{{ modalType === DispositionModalTypes.Create ? 'Create' : 'Edit' }} Disposition</span>
  <!-- Name -->
  <div class="form-item full-width">
    <ah-asset-field-input
      [group]="form"
      [field]="nameField"
      [fullWidth]="true"
      [required]="true"
      class="full-width"
      (blur)="handleNameInput()"
    ></ah-asset-field-input>
  </div>
  <!-- Code -->
  <div class="form-item full-width">
    <ah-asset-field-input
      [group]="form"
      [field]="codeField"
      [fullWidth]="true"
      [required]="true"
      class="full-width"
    ></ah-asset-field-input>
  </div>
  <!-- Color -->
  <div class="form-item full-width">
    <ah-asset-field-input
      [group]="form"
      [field]="colorField"
      [fullWidth]="true"
      [required]="true"
      class="full-width"
    ></ah-asset-field-input>
  </div>
</div>
<div class="button-container flex justify-flex-end gap-20">
  @if (saving) {
    <mat-spinner [diameter]="32"></mat-spinner>
  }
  <button mat-raised-button matDialogClose [disabled]="saving" class="cancel-button-padding">Cancel</button>
  <button mat-raised-button color="primary" (click)="onSave()" [disabled]="saving || form.invalid" class="save-button-padding">Save</button>
</div>
